import BLBPicture from './BLBPicture.vue';

export default BLBPicture;
